import { useQuery } from '@tanstack/react-query'
import { CHURCHES } from '../constants/endpoints'
import { getPublicChurches } from '../utils/getPublicChurches'

export const usePublicChurchesQuery = () => {
  return useQuery({
    queryKey: [CHURCHES, 'public'],
    queryFn: getPublicChurches,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
